// extracted by mini-css-extract-plugin
export var notificationHost = "_cv-0";